import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Pages
import HomePage from "./pages/HomePage";
import MissionVisionPage from "./pages/about/MissionVisionPage";
import ValuesPage from "./pages/about/ValuesPage";
import HistoryPage from "./pages/about/HistoryPage";
import BoardPage from "./pages/about/BoardPage";
import StaffPage from "./pages/about/StaffPage";
import FoodPage from "./pages/gethelp/FoodPage";
import PartnerAgenciesPage from "./pages/gethelp/PartnerAgenciesPage";
import EmergencyAssistancePage from "./pages/gethelp/EmergencyAssistancePage";
import UtilityRentalAssistancePage from "./pages/gethelp/UtilityRentalAssistancePage";
import ResourcesEnglishPage from "./pages/gethelp/ResourcesEnglishPage";
import ResourcesSpanishPage from "./pages/gethelp/ResourcesSpanishPage";
import EnglishClassPage from "./pages/gethelp/EnglishClassPage";
import MediaPage from "./pages/news/MediaPage";
import NewsletterPage from "./pages/news/NewsletterPage";
import FinancialSupportPage from "./pages/waystohelp/FinancialSupportPage";
import ItemsNeededPage from "./pages/waystohelp/ItemsNeededPage";
import VolunteerPage from "./pages/waystohelp/VolunteerPage";
import SponsorsPage from "./pages/SponsorsPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about/mission-vision" element={<MissionVisionPage />} />
          <Route path="/about/values" element={<ValuesPage />} />
          <Route path="/about/history" element={<HistoryPage />} />
          <Route path="/about/board" element={<BoardPage />} />
          <Route path="/about/staff" element={<StaffPage />} />
          <Route path="/get-help/food" element={<FoodPage />} />
          <Route path="/get-help/partner-agencies" element={<PartnerAgenciesPage />} />
          <Route path="/get-help/emergency-assistance" element={<EmergencyAssistancePage />} />
          <Route path="/get-help/utility-rental-assistance" element={<UtilityRentalAssistancePage />} />
          <Route path="/get-help/resources-english" element={<ResourcesEnglishPage />} />
          <Route path="/get-help/resources-spanish" element={<ResourcesSpanishPage />} />
          <Route path="/get-help/english-class" element={<EnglishClassPage />} />
          <Route path="/news/in-the-news" element={<MediaPage />} />
          <Route path="/news/newsletter" element={<NewsletterPage />} />
          <Route path="/ways-to-help/financial-support" element={<FinancialSupportPage />} />
          <Route path="/ways-to-help/items-needed" element={<ItemsNeededPage />} />
          <Route path="/ways-to-help/volunteer" element={<VolunteerPage />} />
          <Route path="/sponsors" element={<SponsorsPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
